import axios from '../../utils/axios2'

export default {
    
    namespaced: true,

    state: {
        workshops: [],
        workshop: null
    },

    getters: {

    },

    mutations: {
        setAllWorkshops(state, payload) {
            state.workshops = payload;
        },
        setWorkshop(state, payload) {
            state.workshop = payload;
        }
    }, 

    actions: {
        storeWorkshop({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: 'workshops',
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                }).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response.data)
                }) 
            });
        },
        fetchAll({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: 'workshops',
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                }).then(response => {
                    commit('setAllWorkshops', response.data);
                    resolve(response.data);
                }).catch(error => {
                    reject(error)
                }) 
            })
        },
        removeWorkshop({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `workshops/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        showWorkshop({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `workshops/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setWorkshop', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        updatedWorkshop({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `workshops/${payload.recordId}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        }
    }
}